import { ref } from "vue";
import axios from "axios";
import { useToast } from "vue-toastification";

export default function useRoles() {
    const roles = ref([]);
    const canAction=ref([]);
    const toast = useToast();

    const getRoles = async () => {
        let response = await axios.get("/api/admin/roles");
        roles.value = response.data.data;
        return response
        // canAction.value=response.data.can;
    };

    const createRole = async (role) => {
        await axios.post("/api/admin/roles", role)
    };

    const updateRole = async (role) => {
        await axios.patch(`/api/admin/roles/${role.id}`, role)
    };

    const destroyRole = async (roleId) => {
        await axios.delete(`/api/admin/roles/${roleId}`)
    };

    const assignPermission = async (rolePermission ,roleId) => {
        await axios.post(`/api/admin/setting/roles/${roleId}/permissions/`, rolePermission)
    };

    return {
        roles,
        createRole,
        updateRole,
        destroyRole,
        getRoles,
        canAction,
        assignPermission
    };
}
